export default __webpack_public_path__ + "static/PlayfairDisplay-Regular-2b99f058d1d1f0ee29bb8e8624b53219.woff2";